"use strict";
class DeveloperUnitDetailsController {
    constructor($scope, $window, SSHttpService, SSUtilService, SSAlertService, SSUserService, SSConfigService, SSAppService, SSConfirmationService, OTPService) {
        const self = this;

        self.$scope = $scope;
        self.$window = $window;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.SSUserService = SSUserService;
        self.SSConfigService = SSConfigService;
        self.SSAppService = SSAppService;
        self.OTPService = OTPService;
        self.SSConfirmationService = SSConfirmationService;

        self.data = SHOWSUITE.data;

        self.has_access = false;
        if (self.SSUserService.isDeveloper()) {
            self.init();
            self.has_access = true;
        }
    }

    init() {
        const self = this;

        if(!!self.data && self.data.unit){
            self.unit = self.formatUnitData(self.data.unit);
            console.log('self.unit');
            console.log(self.unit);
        }

        self.getAssets();
    }

    getAssets(){
        const self = this;

        return self.SSAppService.getPropertyAssetsForCarousel(self.data.property);
    }

    formatUnitData(unit) {
        const self = this;

        unit.formatted_unit_no = self.SSUtilService.getFullUnitNumber(unit);

        unit.formatted_category = self.SSConfigService.getUnitCategoryName(unit.category);
        unit.formatted_type = self.SSConfigService.getUnitTypeName(unit.type);
        unit.formatted_category = self.SSConfigService.getUnitCategoryName(unit.category);
        unit.formatted_status = self.SSConfigService.getUnitStatusName(unit.status);
        unit.formatted_price_type = self.SSConfigService.getUnitPriceTypeName(unit.price_type);
        unit.formatted_floor_plan_type = unit.floor_plan ? unit.floor_plan : '';
        // unit.formatted_floor_plan_type = self.searchArray(self.floorPlans, unit.floor_plan_id);
        unit.actual_price = unit.price;
        unit.formatted_kitchen_type = self.getKitchenType(unit);
        unit.formatted_water_closet = self.getWaterCloset(unit);

        if (self.data.stack) {
            unit.block_no = self.data.stack.block_no;
            unit.stack_name = self.data.stack.name;
        }

        return unit;
    }

    onDeleteUnit(){
        const self = this;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to delete this unit?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                let url = 'sec/developer/properties/' + self.data.property_id + '/' + self.unit.id + '/delete';
                loading(true);
                self.SSHttpService.postAPIRequest(url).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        self.SSAlertService.danger('Error! :',response.message);
                        return;
                    }
                    else{
                        self.SSAlertService.success('Success! :',response.message);
                    }
                });
            }
        );
    }

    getKitchenType(unit){
        const self = this;

        let kitchen_type = self.SSConfigService.getUnitKitchenTypeName(unit.kitchen_type);

        // dry_kitchen variable can have values 0, 1, 2 upto x
        // 0 -> no dry kitchen
        // value 1 or above -> number of kitchens 
        if(unit.dry_kitchen){
            kitchen_type += ' - Dry Kitchen';
            if(unit.dry_kitchen > 1){
                kitchen_type += ' ' + unit.dry_kitchen;
            }
        }
        return kitchen_type;
    }

    getWaterCloset(unit){
        const self = this;

        if(unit.water_closet){
            return unit.water_closet;
        }
        else{
            return '--';
        }
    }

    getWaterCloset(unit){
        const self = this;

        if(unit.appliances){
            return unit.water_closet;
        }
        else{
            return '--';
        }
    }

    getSplittedValues(value){
        const self = this;

        let splitted_values = [];

        if(value){ 
            let arr = value.split('\n');
            for(var index = 0; index < arr.length; index++){
                splitted_values.push(arr[index]); 
            }
        }
        else{
            splitted_values.push('--');
        }

        return splitted_values;
    }

    goToAddCommission(){
        const self = this;

        self.$window.location = '/developer/properties/' + self.data.property_id + '/units/' + self.unit.id + '/commission-incentives';
    }

}

DeveloperUnitDetailsController.$inject = ['$scope', '$window', 'SSHttpService', 'SSUtilService', 'SSAlertService', 'SSUserService', 'SSConfigService', 'SSAppService', 'SSConfirmationService', 'OTPService'];
app.controller('DeveloperUnitDetailsController', DeveloperUnitDetailsController);
